class Faq extends HTMLElement {
    constructor() {
        super();

        const questions = this.querySelectorAll('.question');
        for (const question of questions) {
            const button = question.querySelector('.open-button');
            const height = question.querySelector('.answer').scrollHeight;
            question.style.setProperty('--max-height', height + 'px');

            button.addEventListener('click', () => {
                questions.forEach((q) => {
                    if (q != question) {
                        q.classList.remove('--revealed');
                        q.querySelector('button').setAttribute('aria-expanded', 'false');
                    }
                });
                question.classList.toggle('--revealed');
                button.setAttribute('aria-expanded', question.classList.contains('--revealed'));
            });
        }
    }
}

customElements.define('frequently-asked-questions', Faq);
